'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _reactI18next = require('react-i18next');

var _projects = require('helpers/projects');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ProjectBreadcrumbs.scss');

var ProjectBreadcrumbs = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ProjectBreadcrumbs, _Component);

  function ProjectBreadcrumbs() {
    (0, _classCallCheck3.default)(this, ProjectBreadcrumbs);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectBreadcrumbs.__proto__ || (0, _getPrototypeOf2.default)(ProjectBreadcrumbs)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectBreadcrumbs, [{
    key: 'renderCrumb',
    value: function renderCrumb(section, title) {
      var isProjectRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var _props = this.props,
          projectId = _props.projectId,
          projectType = _props.projectType,
          activeSection = _props.activeSection,
          notClickable = _props.notClickable;

      var isClickable = !notClickable && (projectId || !isProjectRequired);

      return isClickable ? _react2.default.createElement(
        _reactRouter.Link,
        { className: styles.breadcrumb, to: '/projects/' + projectType + '/' + projectId + '/' + section, activeClassName: 'active' },
        _react2.default.createElement(
          'div',
          { className: styles.breadcrumbContent },
          title
        )
      ) : _react2.default.createElement(
        'span',
        { className: (0, _bind2.default)(styles.breadcrumb, { active: activeSection === section }) },
        _react2.default.createElement(
          'div',
          { className: styles.breadcrumbContent },
          title
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          projectType = _props2.projectType;

      var infoTitle = projectType === _projects.projectTypes.sharespace ? t('Sharespace Information') : t('Project Information');
      var materialsTitle = projectType === _projects.projectTypes.video ? t('Video & Press Material') : t('Audio & Press Material');
      var recipientsTitle = t('Recipients');
      var confirmationTitle = t('Confirmation');

      return _react2.default.createElement(
        'div',
        { className: styles.breadcrumbs },
        this.renderCrumb('info', infoTitle, false),
        this.renderCrumb('materials', materialsTitle, false),
        projectType !== _projects.projectTypes.sharespace && this.renderCrumb('recipients', recipientsTitle, false),
        projectType !== _projects.projectTypes.sharespace && this.renderCrumb('confirmation', confirmationTitle)
      );
    }
  }]);
  return ProjectBreadcrumbs;
}(_react.Component), _class3.propTypes = {
  activeSection: _propTypes2.default.string,
  notClickable: _propTypes2.default.bool,
  projectId: _propTypes2.default.number,
  projectType: _propTypes2.default.string,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'renderCrumb', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'renderCrumb'), _class2.prototype)), _class2)) || _class);
exports.default = ProjectBreadcrumbs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Project/Breadcrumbs/ProjectBreadcrumbs.js
// module id = 2046
// module chunks = 1